import { setLocale } from "yup";

setLocale({
  mixed: {
    required: "Required field",
  },
  number: {
    min: ({ min }) => `Must be at least ${min}`,
    max: ({ max }) => `Must be at most ${max}`,
  },
});
